// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-container {
  border: 1px solid #e1e5eb;
  border-radius: 4px;
  margin-bottom: 20px;
  background-color: #fff;
}

.block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e1e5eb;
}

.block-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.block-actions .block-action-btn {
  background: none;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 5px;
}

.block-actions .block-action-btn:hover {
  color: #343a40;
}

.block-actions .block-action-btn.remove {
  color: #dc3545;
}

.block-actions .block-action-btn.remove:hover {
  color: #c82333;
}

.video-preview, .video-preview-placeholder {
  border: 2px dashed #dee2e6;
  border-radius: 4px;
  padding: 40px 20px;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/HomePage/VideoAndTextBlock/VideoAndTextBlock.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".block-container {\n  border: 1px solid #e1e5eb;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  background-color: #fff;\n}\n\n.block-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e1e5eb;\n}\n\n.block-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.block-actions .block-action-btn {\n  background: none;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  color: #6c757d;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.block-actions .block-action-btn:hover {\n  color: #343a40;\n}\n\n.block-actions .block-action-btn.remove {\n  color: #dc3545;\n}\n\n.block-actions .block-action-btn.remove:hover {\n  color: #c82333;\n}\n\n.video-preview, .video-preview-placeholder {\n  border: 2px dashed #dee2e6;\n  border-radius: 4px;\n  padding: 40px 20px;\n  background-color: #f8f9fa;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
